import React from "react";
import { Control, Controller, DeepMap, FieldError } from "react-hook-form";
import { Company, EmailAddress, Phone } from "../../../core/api/models";
import { DropdownList } from "react-widgets";
import Countries from "../../../utils/countries.json";
import ErrorMessage from "../../../components/text/ErrorMessage";
import CustomerEmail from "../../../components/customer-email";
import { Validate965DigitPhoneNumber, ValidateEmail } from "../../../utils/Validatation";
import CustomerPhone from "../../../components/customer-phone";

interface CreateCompanyGlobalFormProps {
    cities: { name: string; value: string; }[];
    control: Control<Company>;
    districtList: never[];
    errors: DeepMap<Company, FieldError>;
    isEmailEnable: boolean;
    onChangeEmail: (emailAdd: EmailAddress[]) => void;
    onChangePhone: (phoneNumber: Phone[]) => void;
    props: any;
    selectedEmail: EmailAddress[] | undefined;
    selectedPhone: Phone[] | undefined;
    setDistrictList: React.Dispatch<React.SetStateAction<never[]>>;
    setValue: (name: string, value: unknown, config?: Partial<{ shouldValidate: boolean; shouldDirty: boolean; }> | undefined) => void;
    statesList: any;
    watch: any
}


export function CreateCompanyGlobalForm({ cities,
    control,
    districtList,
    errors,
    isEmailEnable,
    onChangeEmail,
    onChangePhone,
    props,
    selectedEmail,
    selectedPhone,
    setDistrictList,
    setValue,
    statesList,
    watch }: CreateCompanyGlobalFormProps) {
    return (
        <>
            <div className="col-12 py-3 border-bottom mb-3 py-1 font-base font-weight-semibold">
                Global HeadQuater's
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Country:<span className="text-danger">*</span>
                </label>
                <Controller
                    control={control}
                    rules={{ required: true }}
                    defaultValue={"India"}
                    name="country"
                    render={({ onChange, value, name }) => (
                        <DropdownList
                            value={value}
                            defaultValue={value}
                            data={Countries}
                            textField={"name"}
                            valueField={"name"}
                            placeholder={"Select country"}
                            onChange={(val) => {
                                onChange(val.name);
                            }}
                            filter={"contains"}
                        />
                    )}
                />
            </div>
            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    State:
                </label>
                <Controller
                    control={control}
                    name="stateName"
                    render={({ onChange, value, name }) => (
                        <DropdownList
                            value={value}
                            defaultValue={value}
                            data={statesList}
                            textField={"state"}
                            valueField={"state"}
                            placeholder={"Select state"}
                            onChange={(val) => {
                                setValue("district", '');
                                onChange(val.state);
                                setDistrictList(val.districts);
                            }}
                        />
                    )}
                />
                {errors.state && (
                    <ErrorMessage>
                        {errors.state.type === "required"
                            ? "State is required"
                            : "Invalid State"}
                    </ErrorMessage>
                )}
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    District:
                </label>
                <Controller
                    control={control}
                    name="district"
                    render={({ onChange, value, name }) => (
                        <DropdownList
                            value={value}
                            defaultValue={value}
                            data={districtList?.map((d: string) => {
                                return {
                                    name: d,
                                };
                            })}
                            textField={"name"}
                            valueField={"name"}
                            placeholder={"Select district"}
                            onChange={(val) => {
                                onChange(val.name);
                            }}
                        />
                    )}
                />
                {errors.district && (
                    <ErrorMessage>
                        {errors.district.type === "required"
                            ? "District is required"
                            : "Invalid District"}
                    </ErrorMessage>
                )}
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    City:
                </label>
                <Controller
                    name="cityId"
                    control={control}
                    // rules={{
                    //   required: {
                    //     value: true,
                    //     message: "City is required",
                    //   },
                    // }}
                    render={({ onChange, value }) => (
                        <DropdownList
                            value={value}
                            data={watch("country") === "India" ? cities : []}
                            busy={cities?.length === 0}
                            textField="name"
                            valueField={"value"}
                            filter="contains"
                            onChange={(val) => {
                                onChange(val);
                                // setValue("preferredLocations", []);
                            }}
                            placeholder="Select City"
                        />
                    )}
                />
                {/* {errors.city && <ErrorMessage>{errors.city.message}</ErrorMessage>} */}
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Zip code:
                </label>
                <Controller
                    control={control}
                    // rules={{
                    //   required: true,
                    //   validate: (value) => {
                    //     return !!value.trim();
                    //   },
                    // }}
                    rules={{
                        required: false,
                        pattern: {
                            value: /^[0-9]{6}$/,
                            message: "Invalid Zip Code",
                        },
                    }}
                    name="zipCode"
                    render={({ onChange, value, name }) => (
                        <input
                            type="text"
                            className="form-control rounded-sm font-weight-semibold"
                            placeholder="Zip Code"
                            name={name}
                            value={value}
                            onChange={onChange}
                        // id="postalCode"
                        />
                    )}
                />
                {errors.zipCode && (
                    <ErrorMessage>
                        {errors.zipCode.type === "required"
                            ? "ZIP Code is required"
                            : "Invalid Zip Code"}
                    </ErrorMessage>
                )}
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Building Address:
                </label>
                <Controller
                    control={control}
                    // rules={{ required: true }}
                    name="address"
                    render={({ onChange, value, name }) => (
                        <input
                            type="text"
                            className="form-control rounded-sm font-weight-semibold"
                            placeholder="Building Address"
                            name={name}
                            value={value}
                            onChange={onChange}
                            id="address"
                        />
                    )}
                />
                {errors.address && (
                    <ErrorMessage>
                        {errors.address.type === "required"
                            ? "Building Address is required"
                            : "Invalid Building Address"}
                    </ErrorMessage>
                )}
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Email:
                </label>
                <Controller
                    control={control}
                    rules={{
                        // required: true,              
                        validate: (value) => {
                            if (!selectedEmail?.length) {
                                return true;
                            }
                            // If email is enabled, check if ALL emails are valid
                            return !isEmailEnable || selectedEmail?.every(x => ValidateEmail(x.email));
                        },
                    }}
                    name="emails"
                    defaultValue={props.emails}
                    render={({ onChange, value, name }) => (
                        <CustomerEmail
                            className="form-control p-0 rounded-sm font-weight-semibold"
                            placeholder="Email"
                            value={selectedEmail}
                            onChange={onChangeEmail}
                            disabled={!isEmailEnable}
                        />
                    )}
                />
                {errors.emails && (
                    <div>
                        <ErrorMessage>Valid email is required</ErrorMessage>
                    </div>
                )}
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Phone:
                </label>
                <Controller
                    control={control}
                    rules={{
                        // required: true,
                        validate: (value) => {
                            if (selectedPhone?.length && selectedPhone?.every((x) => x?.phone === x?.dialCode || x?.phone === `+${x?.dialCode}` || x?.phone === '')) {
                                return true
                            }
                            return !(
                                // !selectedPhone ||
                                (selectedPhone &&
                                    selectedPhone?.filter((x) =>
                                        Validate965DigitPhoneNumber(`${x?.phone}`)
                                    ).length !== selectedPhone?.length)
                            );
                        },
                    }}
                    name="phones"
                    render={({ onChange, value, name }) => (
                        <CustomerPhone
                            className="form-control p-0 rounded-sm font-weight-semibold"
                            placeholder="Phone"
                            value={selectedPhone}
                            onChange={(val) => {
                                onChangePhone(val);
                                onChange(val);
                            }}
                        />
                    )}
                />
                {errors.phones && (
                    <div>
                        <div>
                            {!selectedPhone ? (
                                <ErrorMessage>Valid Phone is required</ErrorMessage>
                            ) : (
                                <>
                                    {selectedPhone?.filter(
                                        (x) =>
                                            !!(
                                                (`${x.phone}`).startsWith("91") || (`${x.phone}`).startsWith("+91")
                                            )
                                    ).length > 0 ? (
                                        <ErrorMessage>
                                            Phone number should be 10 digits
                                        </ErrorMessage>
                                    ) : (
                                        <ErrorMessage>Invalid Phone number</ErrorMessage>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                )}
            </div>

        </>
    );
}
